const common = {
    present: "現在",
    user: "使用者",
    menu_overview: "總覽",
    menu_resume: "履歷",
    menu_portfolio: "作品",
    menu_autobio: "自傳",
    menu_login: "登入",
    menu_logout: "登出",
    menu_account: "帳戶",
    loading_msg: "載入中，請稍後...",
    today: "今天",
    chat_tooltip: "聯絡我",
    chat_placeholder: "請輸入訊息"
};

const overview = {
    overview_title1: "KH的",
    overview_title2: "個人網站",
    overview_introduction: `
        這是個個人展示用的網站，展示開發各式各樣的系統平台，以及佈署到地上或雲上的能力，
        不論是前端、後端、或是系統建構與維運等任務皆能妥善完成，
        除了UI設計，因為沒有任何藝術天份...
    `,
    overview_scenarios: "應用情境",
    overview_video1_title: "事件地圖",
    overview_video2_title: "車輛報表",
    overview_video3_title: "路線規劃",
    overview_video4_title: "多國語系",
    overview_video5_title: "單一登入",
    overview_video6_title: "微前端",
    overview_video7_title: "持續整合及佈署",
    overview_video1_desc: `
        可呈現車輛違規事件類別、嚴重性及位置的地圖，並可依據時間範圍、嚴重性、事件類別及車牌號碼過濾事件資料，
        此外，可從事件列表上的影片播放按鈕中，進一步還原當時事件發生時的影像。
    `,
    overview_video2_desc: `
        一個用於事件統計的圖形化儀表板，可依據時間範圍呈現該段時間內的事件統計，
        統計分類大致可分為事件嚴重性統計、事件類別統計、事件趨勢統計，以及各車輛事件統計。
        事件嚴重性統計為依據事件嚴重性計算事件發生的數量。事件類別統計為計算各事件發生的數量。
        事件趨勢統計可依據年、月、日等不同時間顆粒度，並在該時間範圍的過濾條件下統計各事件發生次數的趨勢。
        各車輛事件統計則為計算各車輛在各事件類別上發生的次數統計。
    `,
    overview_video3_desc: `
        展示車輛派送服務的路徑規劃功能。選取起訖點後，系統便會計算尋找出最佳路線，
        將該路線及其相關詳細資訊呈現於地圖上。此外，可在該路線段上新增或刪除中間停留點，
        以達到更靈活的路線規劃。
    `,
    overview_video4_desc: `
        為因應國際化而實現多語言的功能。在登入畫面使用者可依據喜好設定不同的語言，
        登入後在各頁面即可呈現使用者偏好的語言設定。
    `,
    overview_video5_desc: `
        展示在不同平台系統上的單一登入功能。可讓使用者僅需輸入一次帳號密碼，即可在各個系統中來去自如，
        在安全性上不僅可防止釣魚攻擊，亦可預防使用者對密碼記憶與輸入的疲勞。
    `,
    overview_video6_desc: `
        此為一個微前端架構的展示，其精神來自於微服務，將各功能頁面切割並獨立出為元件，
        在該架構下即可在不需過多修改的情況下，靠各元件組合搭配出欲提供的功能服務。
    `,
    overview_video7_desc: `
        此為一個展示自動化的開發流程，當開發人員將程式碼推上GitLab後，即會觸發持續整合及佈署的流程，
        過程中會進行單元/整合測試、程式碼編譯以及最後的程式碼佈署等階段，
        待整個流程皆順利跑完沒有錯誤後，全程不需要任何的人為介入，在伺服器端即會有一個新版本的服務誕生。
    `
};

const resume = {
    resume_info: "個人資料",
    resume_info_lable_name: "姓名",
    resume_info_lable_email: "電子信箱",
    resume_info_name: "李坤翰",
    resume_education: "教育程度",
    resume_education_college: "國立台灣科技大學",
    resume_education_college_master_date: "2013年6月",
    resume_education_college_master: "電子工程所",
    resume_education_college_bachelor_date: "2010年2月",
    resume_education_college_bachelor: "電子工程系",
    resume_exp: "工作經驗",
    resume_exp_wistron: "緯創資通",
    resume_exp_wistron_title: "技術副理 / 軟體開發三部",
    resume_exp_wistron_work1_title: "自動駕駛資訊整合平台",
    resume_exp_wistron_work2_title: "智慧事件資料紀錄器",
    resume_exp_wistron_work3_title: "人工智慧模型管理平台",
    resume_exp_wistron_work4_title: "智慧事件輔助之車隊管理平台",
    resume_exp_wistron_work1_desc: "開發一可監控與管理智慧巴士之自動駕駛平台，是為第一個進行容器化的服務。",
    resume_exp_wistron_work2_desc: "開發一個基於Kubernates進行佈建的影像偵測管理平台，可提供事件及邊緣運算設備的管理。",
    resume_exp_wistron_work3_desc: "於受AWS管理的Kubernates服務上佈建Kubeflow服務，並開發一自動化流程供AI模型持續訓練及佈署。",
    resume_exp_wistron_work4_desc: "於AWS服務上佈建及開發一車隊管理平台，可供追蹤車輛、駕駛員、路線派送等監控及管理。",
    resume_exp_iii: "財團法人資訊工業策進會",
    resume_exp_iii_title: "工程師 / 智慧通訊研究所",
    resume_exp_iii_work1_title: "智慧聯網在地型防救災資通訊平台",
    resume_exp_iii_work2_title: "智慧遠端設備及自動化環境安全管理系統",
    resume_exp_iii_work3_title: "nCare物聯網管理系統",
    resume_exp_iii_work4_title: "聖露西亞G-Net管理系統",
    resume_exp_iii_work5_title: "D-Link邊緣雲端系統",
    resume_exp_iii_work6_title: "新世代移動交通深度學習智慧系統",
    resume_exp_iii_work1_desc: "開發一環境感知系統，其系統可監控架設在區域範圍5公里內之環境感測器，並監測該區域內之天災，如：降雨、 淹水、颱風、地震等，當超過設定之告警閥值時會自動發出電子郵件告知相關人員以進行救援。此外亦 開發一 Android 應用程式當偵測到地震發生時可即時發出警訊告知使用者，實現更靈活性之告警應用。",
    resume_exp_iii_work2_desc: "開發一工業設備管理系統 WebAccess/NMS。該系統基於分散式架構可管理至多 4,000 台支援 SNMP 協定之工業設備，此外此系統之功能包括：設備拓樸掃描、設備狀態儀表板、設備事件紀錄、設備管理 等功能。",
    resume_exp_iii_work3_desc: "開發一物聯網管理系統 IWF 800 nCare。該系統除可支援 SNMP、ICMP、CAPWAP、Modbus 等通訊協定，以監控及管理新漢設備。此外亦開發一 iOS 應用程式 nCare to GO，搭配主系統可進行遠端之管理，實現較靈活性之管理應用。",
    resume_exp_iii_work4_desc: "開發一套簡易版之網管系統並安裝於邦交國家-聖露西亞，其功能包含簡易之設備拓樸顯示、事件紀錄、設備管理、站點管理等功能，雖是為一簡易型網管系統，卻是首次推廣於國外之自家產品。",
    resume_exp_iii_work5_desc: "於 AWS 上開發一網管系統，可通過 TR-069 協定管理其設備，包含：自動探索設備、 遠端設定設備、韌體更新等功能。",
    resume_exp_iii_work6_desc: "開發一交通事件告警與預警模組功能，其使用了深度學習作為物件之辨識與軌跡預測作為基礎，並結合交通世間之邏輯判斷，如：違停、行駛斑馬線、行駛人行道等事件，",
    resume_skill: "技能",
    resume_skill_programming: "程式能力",
    resume_skill_computer: "電腦軟體",
    resume_skill_language: "語言能力",
    resume_skill_language_items: "中文(母語), 英文(讀、寫能力佳，聽、說能力良好)",
    resume_achivement: "成就",
    resume_achivement_aws: "AWS認證解決方案架構師-助理級 (SAA-C02)",
    resume_achivement_aws_date: "2022年8月",
    resume_achivement_scrum: "Scrum Master 認可證照",
    resume_achivement_scrum_date: "2021年9月",
    resume_achivement_ai: "台灣人工智慧學校第三期技術專班結業證書",
    resume_achivement_ai_date: "2019年1月",
    resume_achivement_iii: "績優人員技術菁英獎",
    resume_achivement_iii_date: "2016年8月",
    resume_patent: "專利",
    resume_patent_ai: "更新神經網路模型的方法和電子裝置",
    resume_patent_ai_date: "2022年1月",
    resume_patent_ews: "防救災監測管理和預警系統以及方法",
    resume_patent_ews_cn: "CN105225447B，中國",
    resume_patent_ews_cn_date: "2017年12月",
    resume_patent_ews_us: "US9373247B2，美國",
    resume_patent_ews_us_date: "2016年7月",
    resume_patent_ews_tw: "I537889，台灣",
    resume_patent_ews_tw_date: "2016年6月",
    resume_publication: "論文/期刊發表",
    resume_publication8_date: "2016年8月",
    resume_publication7_date: "2015年11月",
    resume_publication6_date: "2015年9月",
    resume_publication5_date: "2013年8月",
    resume_publication4_date: "2013年7月3-5日",
    resume_publication3_date: "2013年4月",
    resume_publication2_date: "2012年5月6-9日",
    resume_publication1_date: "2012年"
};

const portfolio = {
    portfolio_work_01: "多功能智慧型室內資訊系統",
    portfolio_work_02: "無線監控保全系統",
    portfolio_work_03: "安卓守衛機器人",
    portfolio_work_04: "無線感測網路監控",
    portfolio_work_05: "智慧聯網在地型防救災資通訊平台",
    portfolio_work_06: "智慧遠端設備及自動化環境安全管理系統",
    portfolio_work_07: "nCare物聯網管理系統",
    portfolio_work_08: "聖露西亞G-Net管理系統",
    portfolio_work_09: "D-Link邊緣雲端系統",
    portfolio_work_10: "新世代移動交通深度學習智慧系統",
    portfolio_work_11: "自動駕駛資訊整合平台",
    portfolio_work_12: "智慧事件資料紀錄器",
    portfolio_work_13: "人工智慧模型管理平台",
    portfolio_work_14: "智慧事件輔助之車隊管理平台"
};

const autobio = {
    autobio_title: "自傳",
    autobio_p1_title: "個人簡介",
    autobio_p1_content: "本人畢業於台灣科技大學電子工程系研究所，喜歡藉由軟體程式設計出各種解決方案，在看到成果的霎那，那種喜悅不可比擬，使我更相信了「科技始終來自於人性」這句話，因此也底定了我朝科技領域方向的發展。",
    autobio_p2_title: "第一份工作",
    autobio_p2_content: "畢業後帶著學校所授予唯二的<b>JAVA</b>與<b>SQL</b>程式語言能力，在這裡開啟了我的第一個系統平台的整合與開發。在這裡的這段期間，讓我學到了不少新知，包括前端所需的<b>HTML</b>、<b>CSS</b>、<b>JS</b>、<b>JSP</b>技術能力， JAVA後端會用到的<b>Struts 2</b>架構以及與終端設備溝通用的<b>Restful</b>、<b>Web Socket</b>、<b>SNMP</b>、<b>Modbus</b>、<b>MQTT</b>、<b>TR-069</b>等通訊協定之應用，最後更不能少了身為一個工程師必須要會的程式版本控管<b>Git</b>，藉由這些新習得的技術與能力，不僅在這陸續產出了不少的系統平台，也使我對工作感到不少的充實與成就，更備受到主管的愛戴，讓我在2016年8月有幸能在這份工作中獲得了績優人才的殊榮，也在2018年讓我有機會能被指派去為期數個月之人工智慧學校進修學習。",
    autobio_p3_title: "第二份工作",
    autobio_p3_content: "在第一份工作中所習得的所有能力已能駕輕就熟，由於不願當那故步自封的井底之蛙個性，驅使了我想向外挑戰的決心，故來到了目前在職中的第二份工作，果不其然，在這裡我見識到了許多新穎的技術，除將我的前後端能力增加<b>ReactJS</b>與<b>NodeJS</b>外，在這裡也認識到了將服務虛擬化並進行佈署的<b>Docker</b>，以及一個具有高可用性的系統，其背後應會有的<b>Redis</b>、<b>RabbitMQ</b>、<b>Keycloak</b>等第三方工具及服務，另外也更進一步學會如何將程式與<b>CI/CD</b>整合，以實現出自動化的持續整合及佈署，可省去許多不必要的人力浪費。2021年9月因團隊運作採Scrum開發模式，欲對其了解故而考取了<b>Scrum master證照</b>。2022年8月則因想讓devOps能力有更進一步提升考取了<b>AWS SAA-C02證照</b>。在這份工作當中除身兼工程師一角外，也有了一次機會擔任小主管角色，帶領小團隊進行系統開發，雖僅是個為期極短的小專案，但也讓我體會到了該如何帶領團隊以及進度的規劃與人力分配等學問。",
    autobio_p4_title: "自我評論",
    autobio_p4_content: "縱使自己已掌握相當多的技術，足以應付雲端前、後端服務的開發與建立，但仍想更近一步精進自己的能力，尤其是近幾年來科技的發展相當迅速，唯有無時不刻的督促自己吸收新知充實自己，培養更廣泛的能力，方能在未來更多新穎技術面前迎刃而解。",
    autobio_footer: "若未來有機會能進入貴公司，我會更進一步地將自己的所學毫不保留地發揮在工作上，憑著取之於社會用之於社會的精神，希望能有機會為貴公司貢獻出自己的一份力量，懇請給予面試機會。"
};

export default {
    ...common,
    ...overview,
    ...resume,
    ...portfolio,
    ...autobio
};